// extracted by mini-css-extract-plugin
export default {"hero":"hero_hero__DKf0C","snap-left":"hero_snap-left__piySQ"};